import { FormControlLabel, Switch, SwitchProps } from "@mui/material";
import { useTranslation } from "react-i18next";

type ConfigSwitchProps = SwitchProps & {
  checkedLabel?: string;
  uncheckedLabel?: string;
};
const ConfigSwitch = (props: ConfigSwitchProps) => {
  const {
    checked,
    checkedLabel = "On",
    uncheckedLabel = "Off",
    ...other
  } = props;
  const { t } = useTranslation();
  const hasLabel = checkedLabel !== "" && uncheckedLabel !== "";
  const labelValue = t(checked ? checkedLabel : uncheckedLabel);
  const label = hasLabel ? labelValue : null;

  return (
    <FormControlLabel
      sx={{
        mx: 0,
        "& .MuiFormControlLabel-label": { mx: 1 },
        width: "fit-content",
      }}
      control={<Switch checked={checked} {...other} />}
      label={label}
      data-testid="config-switch"
    />
  );
};

export default ConfigSwitch;
